import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/_shadcn-ui/tooltip';
import { TSimpleCase } from '@/features/case/_shared/types/case.type';
import { formatDate } from 'date-fns';
import { memo } from 'react';

// Component to render case option in dropdown
type CaseOptionProps = {
  option: TSimpleCase | null;
};
const CaseOption = memo(({ option }: CaseOptionProps) => {
  return (
    <div className="flex flex-col">
      <span className="text-[12px] font-[700] text-[#25151E]">{option?.name || ''}</span>
      <span className="text-[10px] font-[400] text-[#9D9D9C]">
        {option?.createdAt ? formatDate(new Date(option?.createdAt || ''), 'd MMMM yyyy') : '-'}
      </span>
    </div>
  );
});
CaseOption.displayName = 'CaseOption';

// Component to render selected case item
type SelectedCaseItemProps = {
  option: TSimpleCase | null;
  onRemove: (option: TSimpleCase | null) => void;
};
const SelectedCaseItem = memo(({ option, onRemove }: SelectedCaseItemProps) => {
  return (
    <div className="flex items-center gap-[8px] border border-[#0C8DBF] bg-[#E4F8FF] px-[4px] py-[2px] relative rounded-[4px]">
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-[12px] font-[700] text-[#25151E]">{(option?.name || '').slice(0, 12)}...</span>
        </TooltipTrigger>
        <TooltipContent className="z-[100001] bg-white text-[#25151E] text-[12px] font-normal p-2 rounded-lg border">
          <span className="text-[12px] font-[700] text-[#25151E]">{option?.name || ''}</span>
        </TooltipContent>
      </Tooltip>
      <div
        onClick={(e) => {
          e.stopPropagation();
          onRemove(option);
        }}
        className="hover:opacity-70 cursor-pointer ml-1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M10.5 3.5L3.5 10.5" stroke="#0C8DBF" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.5 3.5L10.5 10.5" stroke="#0C8DBF" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
});
SelectedCaseItem.displayName = 'SelectedCaseItem';

export { CaseOption, SelectedCaseItem };
